import { useEffect, useState } from 'react';
import axios from 'axios';
import Navbar from './Navbar';
import React, { Component } from 'react';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

import { Link, useLocation, useNavigate } from 'react-router-dom';

import { Bar } from 'react-chartjs-2';
import CanvasJSReact from '@canvasjs/react-charts';

var CanvasJS = CanvasJSReact.CanvasJS;
var CanvasJSChart = CanvasJSReact.CanvasJSChart;

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

// Function to generate random colors
function generateRandomColor() {
  const letters = "0123456789ABCDEF";
  let color = "#";
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}

const BarChart = ({ gridData, selectedCombinedBarColumns, verticalLabel, horizantalLabel, barRightList,
  connectionNameValue, reportName,
  catalogs, schemas, tables, columns, xandLabelBarColumns }) => {

  const navigate = useNavigate();
  const location = useLocation();
  const [iframeUrl, setIframeUrl] = useState('');
  console.log(JSON.stringify(location.state) + "location.state--------------");

  let selectedCombinedBarColumnsValue = '';
  let verticalLabelValue = '';
  let horizantalLabelValue = '';
  let rightListValue = '';
  let connectionName = '';
  let reportNameValue = '';
  let gridDataValue = '';

  let catalogsList = '';
  let schemasList = '';
  let tablesList = '';
  let columnsList = '';
  let xandLabelBarColumnsValue = '';

  const [barDataSet, setBarDataSet] = useState([]);
  const [barDataSet1, setBarDataSet1] = useState([]);
  const [barDataSet2, setBarDataSet2] = useState([]);
  const [xaxis, setXaxis] = useState([]);
  const [yaxis, setYaxis] = useState([]);



  if (location.state && location.state.selectedCombinedBarColumns !== undefined) {
    const { gridData, selectedCombinedBarColumns, verticalLabel, horizantalLabel,
      barRightList, connectionNameValue, reportName, xandLabelBarColumns } = location.state;

    console.log(selectedCombinedBarColumns); // Output: "name"
    console.log(verticalLabel); // Output: "id"
    console.log(horizantalLabel); // Output: "Name Only"
    console.log(barRightList); // Output: "Name Only"

    selectedCombinedBarColumnsValue = location.state.selectedCombinedBarColumns;
    verticalLabelValue = location.state.verticalLabel;
    horizantalLabelValue = location.state.horizantalLabel;
    rightListValue = location.state.barRightList;
    connectionName = connectionNameValue;
    reportNameValue = reportName;
    gridDataValue = gridData;

    catalogsList = location.state.catalogs;
    schemasList = location.state.schemas;
    tablesList = location.state.tables;
    columnsList = location.state.columns;
    xandLabelBarColumnsValue = xandLabelBarColumns;

    console.log(JSON.stringify(selectedCombinedBarColumnsValue) + "selectedCombinedBarColumnsValueLOC"
      + JSON.stringify(verticalLabelValue) + "verticalLabelValueLOC"
      + JSON.stringify(horizantalLabelValue) + "horizantalLabelValueLOC"
      + JSON.stringify(rightListValue) + "rightListValueLOC");
  } else {

    selectedCombinedBarColumnsValue = selectedCombinedBarColumns;
    verticalLabelValue = verticalLabel
    horizantalLabelValue = horizantalLabel;
    rightListValue = barRightList;
    connectionName = connectionNameValue;
    reportNameValue = reportName;
    gridDataValue = gridData;

    catalogsList = catalogs;
    schemasList = schemas;
    tablesList = tables;
    columnsList = columns;
    xandLabelBarColumnsValue = xandLabelBarColumns;

    console.log(JSON.stringify(selectedCombinedBarColumnsValue) + "selectedCombinedBarColumnsValue");
    console.log(JSON.stringify(verticalLabelValue) + "verticalLabelValue");
    console.log(JSON.stringify(horizantalLabelValue) + "horizantalLabelValue");
    console.log(JSON.stringify(rightListValue) + "rightListValue"
      + JSON.stringify(selectedCombinedBarColumnsValue) + "selectedCombinedBarColumnsValue"
      + JSON.stringify(verticalLabelValue) + "verticalLabelValue"
      + JSON.stringify(horizantalLabelValue) + "horizantalLabelValue");
    console.log(JSON.stringify(gridDataValue) + "gridDataValueBAR");
    console.log(JSON.stringify(xandLabelBarColumnsValue) + "xandLabelBarColumnsValue");
  }


  const handleClick = () => {
    console.log('Bar chart clicked!');

    navigate('/barChart', { state: { selectedCombinedBarColumns, verticalLabel, horizantalLabel, barRightList, connectionName, reportNameValue } });
  };

  console.log(JSON.stringify(selectedCombinedBarColumnsValue) + "selectedCombinedBarColumns");
  console.log(JSON.stringify(verticalLabelValue) + "verticalLabel");
  console.log(JSON.stringify(horizantalLabelValue) + "horizantalLabel");
  console.log(JSON.stringify(rightListValue) + "rightList");

  const [data, setData] = useState({
    labels: [],
    datasets: [],
  });
  useEffect(() => {
    const fetchData = async () => {
      const url = 'product.json'
      //const url = 'https://dummyjson.com/products'
      //const url ='https://dummy.restapiexample.com/api/v1/employees'
      // const url = 'https://jsonplaceholder.typicode.com/users'
      //const url ='https://jsonplaceholder.typicode.com/comments'

      await fetch(url).then((data) => {
        console.log("Api data", data)
        const response = data.json();
        return response
      }).then((response) => {
        console.log("response123", response)
        const xAxisColumnValue = response.map(xaxis => xaxis[selectedCombinedBarColumnsValue]);
        console.log(JSON.stringify(xAxisColumnValue) + "xAxisColumnValue");
        // Loop through each column name in rightListValue and extract values
        const yAxisColumnValue = rightListValue.map(columnName => {
          return response.map(yaxis => yaxis[columnName]);
        });

        console.log(JSON.stringify(yAxisColumnValue) + "yAxisColumnValue");

        setXaxis(xAxisColumnValue);
        setYaxis(yAxisColumnValue);

        const rightListYAxis = rightListValue[0];
        console.log(rightListYAxis);



        const datasets = [];
        if (xandLabelBarColumnsValue && xandLabelBarColumnsValue.length > 0) {
          xandLabelBarColumnsValue.forEach((column) => {
            // Check if the column is present in rightListValue
            if (rightListValue.includes(column)) {
              const columnIndex = xandLabelBarColumnsValue.indexOf(column);
              const dataset = gridDataValue.map((data) => ({
                y: parseInt(data[columnIndex], 10),
                label: data[xandLabelBarColumnsValue.indexOf(selectedCombinedBarColumnsValue)],
                color: generateRandomColor()
              }));

              // Create an object for the dataset and set its properties
              const datasetObject = {
                type: "column", // Set the chart type to column/bar
                dataPoints: dataset,
                // Add other options as needed
                // For example:
                name: column, // Set the dataset name to the column name
                showInLegend: true, // Show the dataset in the legend
              };

              datasets.push(datasetObject);



            }
          });
          console.log(JSON.stringify(datasets) + "datasets");
          setBarDataSet(datasets);
          console.log(JSON.stringify(barDataSet) + "barDataSet");
        }

        // Now, 'datasets' contains datasets for columns present in both 'xandLabelBarColumnsValue' and 'rightListValue'.




        // const datasets = gridDataValue.map(data => ({

        //   y: parseInt(data[1], 10),
        //   label: data[xandLabelBarColumnsValue.indexOf[selectedCombinedBarColumnsValue]],
        //   color: generateRandomColor()
        // }));
        // const datasets1 = gridDataValue.map(data => ({
        //   y: parseInt(data[1], 10),
        //   label: data[xandLabelBarColumnsValue.indexOf(selectedCombinedBarColumnsValue)],
        //   color: generateRandomColor()
        // }));
        // console.log(JSON.stringify(datasets1) + "datasets1***");
        // const datasets2 = gridDataValue.map(data => ({
        //   y: parseInt(data[2], 10),
        //   label: data[xandLabelBarColumnsValue.indexOf(selectedCombinedBarColumnsValue)],
        //   color: generateRandomColor()
        // }));


        // const datasets = response.map((column, index) => {
        //   return {
        //     label: xAxisColumnValue[index],
        //     y: column[rightListValue],
        //     color: generateRandomColor(),
        //     //  backgroundColor: generateRandomColor(), // You can define or generate colors here
        //   };
        // });
        // setBarDataSet(datasets);
        // setBarDataSet1(datasets1);
        // console.log(JSON.stringify(barDataSet1) + "bardataset1***");
        // setBarDataSet2(datasets2);
        // console.log(JSON.stringify(datasets) + "datasets----");

      }).then((res) => {
        console.log("res", res)
      }).
        catch(e => {
          console.log("error", e)
        })
    }
    fetchData();
  },

    [selectedCombinedBarColumnsValue, verticalLabelValue, horizantalLabelValue, rightListValue])


  // const options = {
  //   animationEnabled: true,
  //   theme: "light2",
  //   title: {
  //     text: "BAR CHART"
  //   },
  //   axisX: {
  //     title: selectedCombinedBarColumnsValue,
  //     reversed: true,
  //   },
  //   axisY: {
  //     title: rightListValue[0],
  //     includeZero: true,
  //     //	labelFormatter: this.addSymbols
  //   },
  //   axisY: {
  //     title: rightListValue[1],
  //     includeZero: true,
  //     //	labelFormatter: this.addSymbols
  //   },
  //  // data:barDataSet
  //    data: [{
  //      type: "column",
  //     dataPoints: barDataSet
  //     // dataPoints: [
  //     // 	{ y:  2200000000, label: "Facebook" },
  //     // 	{ y:  1800000000, label: "YouTube" },
  //     // 	{ y:  800000000, label: "Instagram" },
  //     // 	{ y:  563000000, label: "Qzone" },
  //     // 	{ y:  376000000, label: "Weibo" },
  //     // 	{ y:  336000000, label: "Twitter" },
  //     // 	{ y:  330000000, label: "Reddit" }
  //     // ]
  //    },
  //     // {
  //     //   type: "column",
  //     //   dataPoints: barDataSet1
  //     //  //  dataPoints: [
  //     //   // 	{ y:  2200000000, label: "Facebook" },
  //     //   // 	{ y:  1800000000, label: "YouTube" },
  //     //   // 	{ y:  800000000, label: "Instagram" },
  //     //   // 	{ y:  563000000, label: "Qzone" },
  //     //   // 	{ y:  376000000, label: "Weibo" },
  //     //   // 	{ y:  336000000, label: "Twitter" },
  //     //   // 	{ y:  330000000, label: "Reddit" }
  //     //   // ]
  //     // },
  //     // {
  //     //   type: "column",
  //     //   dataPoints: barDataSet2
  //     //   // dataPoints: [
  //     //   // 	{ y:  2200000000, label: "Facebook" },
  //     //   // 	{ y:  1800000000, label: "YouTube" },
  //     //   // 	{ y:  800000000, label: "Instagram" },
  //     //   // 	{ y:  563000000, label: "Qzone" },
  //     //   // 	{ y:  376000000, label: "Weibo" },
  //     //   // 	{ y:  336000000, label: "Twitter" },
  //     //   // 	{ y:  330000000, label: "Reddit" }
  //     //   // ]
  //     // }
  //    ]
  // }

  const options = {
    animationEnabled: true,
    exportEnabled: true,
    theme: "light2",
    title: {
      text: "BAR CHART",
    },
    axisX: {
      title: selectedCombinedBarColumnsValue,
      reversed: true,
    },
    axisY: [
      {
        title: rightListValue && rightListValue.length > 0 ? rightListValue[0] : '',
        includeZero: true,
        // labelFormatter: this.addSymbols
      },
      {
        title: rightListValue && rightListValue.length > 0 ? rightListValue[1] : '',
        includeZero: true,
        // labelFormatter: this.addSymbols
      },
      // Add more axisY objects for additional datasets if needed
    ],
    data: barDataSet, // barDataSet should be an array of data series
  };


  return (
    <div>

      <div className="chart" style={location.state ? { width: '99%', height: '500px' } : { width: '50%', height: '300px' }}>
        {location.state && location.state.selectedCombinedBarColumns !== undefined ? (
          <>
            {/* <h2>Connection Name : {connectionName}</h2> */}
            {/* <h3>Report Name : {reportNameValue}</h3> */}
            <Link to="/QueryBuilder" state={{
              connectionName: connectionName,
              reportName: reportNameValue,
              catalogs: catalogsList,
              schemas: schemasList,
              tables: tablesList,
              columns: columnsList
            }}>Home</Link>
            {/* <Bar data={data} options={options} /> */}
            <CanvasJSChart data={data} options={options} />
          </>

        ) : (
          <CanvasJSChart data={data} options={options} onClick={() => handleClick()} />
          // <Bar data={data} className="left-align" options={options} onClick={() => handleClick()} />

        )}
      </div>
    </div>

  );

}

export default BarChart; 